// mui
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

// hooks
import { useTheme } from '@mui/material';
import useVirgoContent from 'hooks/useVirgoContent';

// components
import Link from 'components/Link';

const chipStyle = {
  mx: 0.5,
  my: 0.25,
  '@media(max-width: 600px)': {
    ml: 0,
    mr: 0.5,
    fontSize: '13px',
  },
  lineHeight: '28px',
  fontSize: '14px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: 'grey.200',
  },
};

const Chips = () => {
  const theme = useTheme();
  const { chips } = useVirgoContent();

  if (!chips?.data || chips?.data?.length <= 0) return null;

  return (
    <Stack
      width="100%"
      direction="row"
      maxWidth="1100px"
      justifyContent="center"
      sx={{
        flexWrap: 'wrap',
        [theme.breakpoints.up('lg')]: {
          pr: '10px',
        },
      }}
      data-testid="fyp-discover-section-container-chips"
    >
      {chips?.data?.map(({ url, id, title }, index) => (
        <Chip
          key={id}
          href={url}
          label={title}
          title={title}
          sx={chipStyle}
          target="_blank"
          component={Link}
          variant="outlined"
          data-testid={`fyp-discover-section-container-chips-chip-${index}`}
        />
      ))}
    </Stack>
  );
};

export default Chips;
